
import ACTS from '../constants'

const defaultStatus = {
    title: '자산관리 / 설정',
    tabId: 'more',
    active: 'list',
    selectedJasan: null,
    resultRegist: null,
    result: null,
    list: [],
    serviceInfo: {} // 수집 기준 데이터
}

export default (state = defaultStatus, action) => {
    let items = {}
    switch(action.type) {
        case ACTS.GET_JASAN_SCRAP:
            return {
                ...state,
                jasanList: !action.error && action.payload.list
            }
        case ACTS.GET_SUMMARY_TODAY_BALANCE:
            return {
                ...state,
                item: !action.error && action.payload.item
            }
        case ACTS.GET_JASAN_ALL:
            return {
                ...state,
                list: !action.error && action.payload.list,
                items: action.payload.item
            }
        case ACTS.GET_JASAN_LIST:
            return {
                ...state,
                list: !action.error && action.payload.list
            }
        case ACTS.SELECTED_CERT:
            return {
                ...state,
                loginMethod: 'CERTIFY',
                selectedCert: action.item
            }
        case ACTS.SELECTED_ACCOUNT:
            return {
                ...state,
                loginMethod: 'LOGIN',
                account: {userId: action.userId, userPw: action.userPw, bubinYn: action.bubinYn, acctNo: action.acctNo, acctPw: action.acctPw}
            }
        case ACTS.SELECTED_JASAN:            
            return {
                ...state,
                selectedJasan: action.item
            }
        case ACTS.REGIST_JASAN:
            return {
                ...state,
                resultRegist: action.payload
            }
        case ACTS.REGIST_JASAN_END:
            return {
                ...state,
                resultRegist: null,
                loginMethod: null,
                account: null
            }
        case ACTS.JASAN_HIDE:
            return {
                ...state,
                list: state.list.filter(t => t.seq !== action.seq),
                result: action.payload
            }
        case ACTS.JASAN_USEYN:
            if(state.selectedJasan.kind === 'bank')
                items = { ...state.items, bankList: state.items.bankList.filter( t => t.seq !== action.seq ) };
            else if(state.selectedJasan.kind === 'card')
                items = { ...state.items, cardList: state.items.cardList.filter( t => t.seq !== action.seq ) };

                return {
                    ...state,
                    items,
                    result: action.payload
                }
        case ACTS.DELETE_JASAN: 
            if(state.selectedJasan.kind === 'bank')
                items = { ...state.items, bankList: state.items.bankList.filter( t => t.seq !== action.seq ) };
            else if(state.selectedJasan.kind === 'card')
                items = { ...state.items, cardList: state.items.cardList.filter( t => t.seq !== action.seq ) };
            
            return {
                    ...state,
                    items,
                    result: action.payload
                }
        case ACTS.JASAN_ACTION_END:
            return {
                ...state,
                selectedJasan: null,
                result: null
            }
        case ACTS.GET_SCRAP_INFOS:
            return {
                ...state,
                serviceInfo: action.info
            }     
        case ACTS.UPDATE_CERTIFY:
            let certifyKindNum = '';
            if(action.certify === 'LOGIN') certifyKindNum = '2';
            else if(action.certify === 'QUICK') certifyKindNum = '3'; 

            items = { ...state.items }
            if(action.kind === 'bank')
                items.bankList.forEach( t => { if(t.seq === action.seq) {t.certifyKindNum = certifyKindNum } });
            else if(action.kind === 'card')
                items.cardList.forEach( t => { if(t.seq === action.seq) t.certifyKindNum = certifyKindNum });
            
            return {
                ...state,
                items,
                resultUpdateCertify: action.payload 
            }     
        case ACTS.UPDATE_CERTIFY_END:
            return {
                ...state,
                selectedJasan: null,
                resultUpdateCertify: null
            }     
        case ACTS.TAB_ASSET_MORE:
            if(state.active === action.active){
                return {
                    ...state,
                    tabId: action.tabId,
                    active: action.active
                }
            }else{
                return {
                    ...state,
                    list: [],
                    tabId: action.tabId,
                    active: action.active
                }
            }
        case ACTS.JASAN_SET_UNMOUNT:
            return {
                ...state,
                selectedJasan: null
            }
        case ACTS.GET_BIZ_NO:             
            return {
                ...state,
                bizNo : action.payload.item.bizNo
            }
        case ACTS.INIT_REGIST_JASAN:             
            return {
                ...state,
                account: null
            }
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/asset.js